var _g, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _g2, _circle, _g3, _g4, _circle2, _g5, _g6, _circle3, _g7, _g8, _circle4, _g9, _g10, _circle5, _g11, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTalentAcquistionDecorator(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 191,
    viewBox: "0 0 185 191",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2901_325)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.896 29.5327H35.5215L92.7255 161.406L146.896 29.5327Z",
    fill: "white"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.5088,
    cy: 137.441,
    rx: 56.9873,
    ry: 27.3019,
    fill: "url(#paint0_radial_2901_325)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.5089,
    cy: 110.572,
    rx: 70.855,
    ry: 27.3019,
    fill: "url(#paint1_radial_2901_325)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.5088,
    cy: 83.7038,
    rx: 77.7888,
    ry: 27.3019,
    fill: "url(#paint2_radial_2901_325)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.5088,
    cy: 56.8346,
    rx: 84.7226,
    ry: 27.3019,
    fill: "url(#paint3_radial_2901_325)"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.5089,
    cy: 36.9003,
    rx: 91.6564,
    ry: 20.3681,
    fill: "url(#paint4_radial_2901_325)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_2901_325)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 113.531,
    cy: 116.949,
    r: 13.9188,
    stroke: "white",
    strokeWidth: 0.451421
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 113.531,
    cy: 116.949,
    r: 14.1445,
    fill: "url(#paint5_linear_2901_325)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2901_325)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.547 124.214C104.524 120.094 108.734 117.25 113.609 117.25C118.484 117.25 122.694 120.094 124.671 124.214C122.095 127.487 118.097 129.589 113.609 129.589C109.12 129.589 105.123 127.487 102.547 124.214ZM118.198 110.855C118.198 113.389 116.144 115.444 113.609 115.444C111.074 115.444 109.019 113.389 109.019 110.855C109.019 108.32 111.074 106.265 113.609 106.265C116.144 106.265 118.198 108.32 118.198 110.855Z",
    fill: "url(#paint6_linear_2901_325)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_2901_325)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 58.6023,
    cy: 22.9243,
    r: 13.9188,
    stroke: "white",
    strokeWidth: 0.451421
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.6023,
    cy: 22.9243,
    r: 14.1445,
    fill: "url(#paint7_linear_2901_325)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2901_325)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.6177 30.189C49.5949 26.0695 53.8054 23.2253 58.6801 23.2253C63.5548 23.2253 67.7653 26.0695 69.7425 30.189C67.1664 33.4623 63.1687 35.5643 58.6801 35.5643C54.1915 35.5643 50.1938 33.4623 47.6177 30.189ZM63.2696 16.8302C63.2696 19.3648 61.2148 21.4196 58.6801 21.4196C56.1455 21.4196 54.0907 19.3648 54.0907 16.8302C54.0907 14.2955 56.1455 12.2407 58.6801 12.2407C61.2148 12.2407 63.2696 14.2955 63.2696 16.8302Z",
    fill: "url(#paint8_linear_2901_325)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_2901_325)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 126.817,
    cy: 62.0473,
    r: 13.9188,
    stroke: "white",
    strokeWidth: 0.451421
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 126.817,
    cy: 62.0473,
    r: 14.1445,
    fill: "url(#paint9_linear_2901_325)"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2901_325)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.832 69.312C117.81 65.1926 122.02 62.3484 126.895 62.3484C131.769 62.3484 135.98 65.1926 137.957 69.312C135.381 72.5854 131.383 74.6873 126.895 74.6873C122.406 74.6873 118.408 72.5853 115.832 69.312ZM131.484 55.9532C131.484 58.4879 129.429 60.5427 126.895 60.5427C124.36 60.5427 122.305 58.4879 122.305 55.9532C122.305 53.4185 124.36 51.3638 126.895 51.3638C129.429 51.3638 131.484 53.4185 131.484 55.9532Z",
    fill: "url(#paint10_linear_2901_325)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_2901_325)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 66.6275,
    cy: 98.1611,
    r: 13.9188,
    stroke: "white",
    strokeWidth: 0.451421
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 66.6275,
    cy: 98.1611,
    r: 14.1445,
    fill: "url(#paint11_linear_2901_325)"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_2901_325)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.643 105.426C57.6203 101.307 61.8306 98.4626 66.7052 98.4626C71.5799 98.4626 75.7903 101.307 77.7675 105.426C75.1914 108.699 71.1938 110.801 66.7053 110.801C62.2167 110.801 58.2191 108.699 55.643 105.426ZM71.2947 92.067C71.2947 94.6017 69.24 96.6564 66.7053 96.6564C64.1706 96.6564 62.1158 94.6017 62.1158 92.067C62.1158 89.5323 64.1706 87.4775 66.7053 87.4775C69.24 87.4775 71.2947 89.5323 71.2947 92.067Z",
    fill: "url(#paint12_linear_2901_325)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_2901_325)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 92.5089,
    cy: 164.743,
    r: 13.9188,
    stroke: "white",
    strokeWidth: 0.451421
  }))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.5089,
    cy: 164.743,
    r: 14.1445,
    fill: "url(#paint13_linear_2901_325)"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_2901_325)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.5244 172.007C83.5016 167.888 87.712 165.044 92.5866 165.044C97.4612 165.044 101.672 167.888 103.649 172.008C101.073 175.281 97.0751 177.383 92.5866 177.383C88.0981 177.383 84.1004 175.281 81.5244 172.007ZM97.1761 158.649C97.1761 161.183 95.1213 163.238 92.5866 163.238C90.052 163.238 87.9972 161.183 87.9972 158.649C87.9972 156.114 90.052 154.059 92.5866 154.059C95.1213 154.059 97.1761 156.114 97.1761 158.649Z",
    fill: "url(#paint14_linear_2901_325)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2901_325",
    x: 6.63056,
    y: 0.64179,
    width: 169.156,
    height: 189.655,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.4455,
    result: "effect1_foregroundBlur_2901_325"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2901_325",
    x: 96.3772,
    y: 99.7947,
    width: 34.3079,
    height: 34.308,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.50474,
    result: "effect1_foregroundBlur_2901_325"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_2901_325",
    x: 41.4483,
    y: 5.77031,
    width: 34.3079,
    height: 34.308,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.50474,
    result: "effect1_foregroundBlur_2901_325"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_2901_325",
    x: 109.663,
    y: 44.8934,
    width: 34.3079,
    height: 34.308,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.50474,
    result: "effect1_foregroundBlur_2901_325"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_2901_325",
    x: 49.4735,
    y: 81.0071,
    width: 34.3079,
    height: 34.308,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.50474,
    result: "effect1_foregroundBlur_2901_325"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_2901_325",
    x: 75.3549,
    y: 147.589,
    width: 34.3079,
    height: 34.308,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.50474,
    result: "effect1_foregroundBlur_2901_325"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2901_325",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(92.5088 137.441) rotate(90) scale(27.3019 56.9873)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7C4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#558CF9",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2901_325",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(92.5089 110.572) rotate(90) scale(27.3019 70.855)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7C4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#558CF9",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2901_325",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(92.5088 83.7038) rotate(90) scale(27.3019 77.7888)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7C4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#558CF9",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2901_325",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(92.5088 56.8346) rotate(90) scale(27.3019 84.7226)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7C4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#558CF9",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_2901_325",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(92.5089 36.9003) rotate(90) scale(20.3681 91.6564)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7C4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#558CF9",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2901_325",
    x1: 103.901,
    y1: 106.641,
    x2: 122.936,
    y2: 129.062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1898,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.06
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2901_325",
    x1: 113.609,
    y1: 106.265,
    x2: 113.609,
    y2: 129.589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2901_325",
    x1: 48.972,
    y1: 12.6169,
    x2: 68.0069,
    y2: 35.0374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1898,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.06
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2901_325",
    x1: 58.6801,
    y1: 12.2407,
    x2: 58.6801,
    y2: 35.5643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2901_325",
    x1: 117.187,
    y1: 51.7399,
    x2: 136.222,
    y2: 74.1605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1898,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.06
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2901_325",
    x1: 126.895,
    y1: 51.3638,
    x2: 126.895,
    y2: 74.6874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2901_325",
    x1: 56.9972,
    y1: 87.8537,
    x2: 76.0321,
    y2: 110.274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1898,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.06
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2901_325",
    x1: 66.7053,
    y1: 87.4775,
    x2: 66.7053,
    y2: 110.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2901_325",
    x1: 82.8786,
    y1: 154.435,
    x2: 101.913,
    y2: 176.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1898,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.06
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2901_325",
    x1: 92.5867,
    y1: 154.059,
    x2: 92.5867,
    y2: 177.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2901_325"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.571,
    height: 23.3234,
    fill: "white",
    transform: "translate(102.547 106.265)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2901_325"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.571,
    height: 23.3234,
    fill: "white",
    transform: "translate(47.6177 12.2407)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2901_325"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.571,
    height: 23.3234,
    fill: "white",
    transform: "translate(115.832 51.3638)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_2901_325"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.571,
    height: 23.3234,
    fill: "white",
    transform: "translate(55.643 87.4775)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_2901_325"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.571,
    height: 23.3234,
    fill: "white",
    transform: "translate(81.5244 154.059)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalentAcquistionDecorator);
export default __webpack_public_path__ + "static/media/TalentAcquistionDecorator.991da8cbca1b0d57a30efcaeac7f8eb1.svg";
export { ForwardRef as ReactComponent };